import React from 'react';
import {useState} from "react";
import Header from '../../Components/Header/header';
import ImageSlider from '../../Components/ImageSlider/imageSlider';
import Reach from '../../Components/Reach/reach';
import FootPage from '../../Components/FooterPage/footPage';
import './Reservation.css';


const resevPage = [
  {
    img: 'restaurant.jpg',
    caption: 'Our Menu',
  }
]

export default function Reservation() {
  const [select, setSelect] = useState("");
  return (
    <div className='reservation'>
      <Header />
      {resevPage.map((reserv, index) => (
        <div className='reserv-container' key={index}>
           <img src={`/images/${reserv.img}`} alt='Reservation' className='reserv-image' />
           <span className='reserv-text'>Reservation 
              <pre>Book a Table Online</pre></span>
        </div>
      ))}
    <div className="Cover-reserved">
      <div className='header-reserv'>Opening Hour 8: 00 AM - 10:00 PM, Every Day On Week</div>
      <div className='reserv-form'>
        
         <select value={select} onChange={e =>setSelect(e.target.value)} className='reserv-select'>
            <option selected='selected'>Date</option>
            <option className='reserv-item'>6th March, 2024</option>
            <option className='reserv-item'>7th March, 2024</option> 
            <option className='reserv-item'>8th March, 2024</option>
            <option className='reserv-item'>9th March, 2024</option>
         </select> 

         <select value={select} onChange={e =>setSelect(e.target.value)} className='reserv-select'>
            <option selected='selected'>Time</option>
            <option className='reserv-item'>08:30am</option>
            <option className='reserv-item'>12:00pm</option> 
            <option className='reserv-item'>03:00pm</option>
            <option className='reserv-item'>07:00pm</option>
         </select> 
         
        </div>
        <div className='reserv-form2'>
        
         <select value={select} onChange={e =>setSelect(e.target.value)} className='reserv-select'>
            <option selected='selected'>Number of Diners</option>
            <option className='reserv-item'>2</option>
            <option className='reserv-item'>3</option> 
            <option className='reserv-item'>4</option>
            <option className='reserv-item'>5</option>
         </select> 

         <select value={select} onChange={e =>setSelect(e.target.value)} className='reserv-select'>
            <option selected='selected'>Occasion</option>
            <option className='reserv-item'>Breakfast</option>
            <option className='reserv-item'>Launch</option> 
            <option className='reserv-item'>Dinner</option>
         </select> 
         
        </div>
        <div onChange={e =>setSelect(e.target.value)} className='reserv-btn'>Make Reservation</div>
        </div>
        <div className='reserv-slide'>
        <ImageSlider />
        </div>
        <Reach />
        <div className="footPage">
          <FootPage />
        </div>
    </div>

  )
}
